import { Header, pxToRem, useStyles } from '@archipro-design/aria';
import type { ReactNode } from 'react';
import * as S from './FeaturedTitle.mobile.style';

const FeaturedTitleMobile = ({ children }: { children?: ReactNode }) => {
    const { css } = useStyles();
    return (
        <Header
            as="h3"
            variant={'01'}
            className={css(S.FeatureTitle)}
            variables={{
                fontSize: pxToRem(18),
                fontWeight: 500,
                lineHeight: '100%',
            }}
        >
            {children}
        </Header>
    );
};

export default FeaturedTitleMobile;
